import React from "react";
import { SortSearch } from "./SortSearch";
import { $Skeleton } from "us.common/components";
import { TabControllerType } from "../Types";

/**
 * @description - Tab controller component with sort management.
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 * */
export const TabController: React.FC<TabControllerType> = (props) => {
  const { isLoading, tabInfo, isSortHidden, changeSortOrderEvent } = props;

  return (
    <$Skeleton loading={isLoading} active paragraph={{ rows: 2 }}>
      {!isSortHidden && (
        <SortSearch
          tabInfo={tabInfo}
          changeSortOrderEvent={changeSortOrderEvent}
        />
      )}
      {props.children}
    </$Skeleton>
  );
};
